import React, { useState, useEffect } from "react";
import {
    Typography,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Box,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    TextField,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    Paper,
    IconButton,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import DeleteIcon from "@material-ui/icons/Delete";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { makeStyles } from "@material-ui/core/styles";

/* ------------------------- Importaciones internas ------------------------- */
import { api } from "../../../services/api";
import { formatearFecha } from "../../../core/utils/formatDate";
import CrearConfiguracion from "../componentes/adicionales/createConfiguracion";
import BotonGenerico from "../../../components/Button/Button";
import DialogFooter from "../../../components/DialogFooter/DialogActions";
// import { useAuth } from "../../../contexts/AuthContext";

/* --------------------------------- Estilos -------------------------------- */
const useStyles = makeStyles((theme) => ({
    headerContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: theme.spacing(2),
    },
    leftButton: {
        display: "flex",
        alignItems: "center",
        textTransform: "none",
        backgroundColor: "green",
        color: "white",
        "&:hover": {
            backgroundColor: "#388e3c",
        },
    },
    dropdownContainer: {
        padding: theme.spacing(2),
        textAlign: "center",
    },
    rightActionsContainer: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            justifyContent: "space-between",
        },
    },
    sectionHeader: {
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    titleText: {
        fontWeight: "bold",
        color: "#333",
        margin: theme.spacing(3),
    },
    formControl: {
        width: "100%",
        marginTop: theme.spacing(2),
    },
    errorIcon: {
        color: "green",
        fontSize: "4rem",
        marginBottom: theme.spacing(2),
    },
    dialogTitle: {
        textAlign: "center",
    },
    dialogContent: {
        textAlign: "center",
    },
    dialogButtons: {
        justifyContent: "center",
    },
    greenButton: {
        color: "green",
        borderColor: "green",
        borderRadius: theme.shape.borderRadius,
        textTransform: "none",
    },
}));

const listaConfiguraciones = [
    { nombre: "Usuario", valor: "usuarios" },
    { nombre: "Rubro", valor: "rubro" },
    { nombre: "Sector", valor: "sector" },
    { nombre: "Tipo de productos", valor: "tipoproducto" },
    { nombre: 'Tipos de comprobantes', valor: 'tipocomprobante' },
    { nombre: 'Evaluaciones de criterios', valor: 'criteriosevaluacion' },
    { nombre: 'Items', valor: 'items' },
];

const Configuraciones = () => {
    const classes = useStyles();
    // const { getUser } = useAuth();
    // const user = getUser();
    // const isGeneralUser = Number(user?.es_admin) === 3;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchText, setSearchText] = useState("");
    const [seccionPrograma, setSeccionPrograma] = useState("");
    const [tablaReferencia, setTablaReferencia] = useState("");
    const [selectedRow, setSelectedRow] = useState(null);
    const [openForm, setOpenForm] = useState(false);
    const [open, setOpen] = useState(false);

    // Estados por sección
    const [usuariosConSector, setUsuariosConSector] = useState([]);
    const [rubro, setRubro] = useState([]);
    const [sectores, setSectores] = useState([]);
    const [tipoProducto, setTipoProducto] = useState([]);
    const [items, setItems] = useState([]);
    const [tipoComprobante, setTipoComprobante] = useState([]);
    const [criteriosEvaluacion, setCriteriosEvaluacion] = useState([]);

    const columnasPorSeccion = {
        usuarios: [
            { key: "IdUsuario", label: "ID" },
            { key: "Nombre", label: "Nombre" },
            { key: "Apellido", label: "Apellido" },
            { key: "email", label: "Email" },
            { key: "Contraseña", label: "Contraseña" },
            { key: "fechaRegistro", label: "Fecha de registro" },
            { key: "Sector", label: "Sector" },
        ],
        rubro: [{ key: "IdRubro", label: "ID" }, { key: "Nombre", label: "Nombre" }],
        sector: [{ key: "IdSector", label: "ID" }, { key: "Nombre", label: "Nombre" }],
        tipoproducto: [{ key: "IdTipoProducto", label: "ID" }, { key: "Nombre", label: "Nombre" }],
        items: [
            { key: "codigoItem", label: "Código" },
            { key: "nombre", label: "Nombre" },
            { key: "Rubro", label: "Rubro" },
            { key: "precioDefault", label: "Precio por defecto" },
        ],
        tipocomprobante: [{ key: "idtipo_comprobante", label: "ID" }, { key: "Nombre", label: "Nombre" }],
        criteriosevaluacion: [{ key: "idcriterios_evaluacion", label: "ID" }, { key: "Nombre", label: "Nombre" }],
    };

    const seccionesConfig = {
        usuarios: {
            api: api.usuarios,
            state: usuariosConSector,
            setState: setUsuariosConSector,
            idKey: "IdUsuario",
        },
        rubro: {
            api: api.rubros,
            state: rubro,
            setState: setRubro,
            idKey: "IdRubro",
        },
        sector: {
            api: api.sectores,
            state: sectores,
            setState: setSectores,
            idKey: "IdSector",
        },
        tipoproducto: {
            api: api.tiposProducto,
            state: tipoProducto,
            setState: setTipoProducto,
            idKey: "IdTipoProducto",
        },
        items: {
            api: api.items,
            state: items,
            setState: setItems,
            idKey: "IdItems",
        },
        tipocomprobante: {
            api: api.tipoComprobante,
            state: tipoComprobante,
            setState: setTipoComprobante,
            idKey: "idtipo_comprobante",
        },
        criteriosevaluacion: {
            api: api.criterios,
            state: criteriosEvaluacion,
            setState: setCriteriosEvaluacion,
            idKey: "idcriterios_evaluacion",
        },
    };

    /**
     * Cambia la sección activa del programa.
     * @param {object} event - El evento que contiene el valor seleccionado.
     */
    const cambiarSeccion = (event) => {
        const valorSeleccionado = event.target.value;
        setSeccionPrograma(valorSeleccionado);
        setTablaReferencia(valorSeleccionado);
        setSearchText("")
        setPage(0);
    };

    const isAccionUsuariosRestringida =
        seccionPrograma === "usuarios";
    // seccionPrograma === "usuarios" && isGeneralUser;

    const columnasVisibles =
        columnasPorSeccion[seccionPrograma]?.filter((col) =>
            !(isAccionUsuariosRestringida && col.key === "Contraseña")
        ) || [];

    /**
     * Agrega un nuevo elemento a la lista de la sección correspondiente.
     * @param {object} nuevoId - Objeto con la información del nuevo elemento.
     * @returns {Promise<void>} - Una promesa que se resuelve cuando se actualiza la lista.
     */
    const agregarElemento = async (nuevoId) => {
        const config = seccionesConfig[seccionPrograma];
        if (!config) return;

        let nuevoObjeto = nuevoId;
        if (nuevoId.id && config.api.getById) {
            nuevoObjeto = await config.api.getById(nuevoId.id);
        }

        if (seccionPrograma === "items") {
            const rubroFiltrado = rubro.find(r => r.IdRubro === nuevoObjeto.IdRubro);
            const itemConRubro = {
                ...nuevoObjeto,
                Rubro: rubroFiltrado ? rubroFiltrado.Nombre : "Sin rubro",
                IdRubro: rubroFiltrado ? rubroFiltrado.IdRubro : "Sin rubro",
            };
            actualizarLista(items, setItems, "IdItem", itemConRubro);
        } else if (seccionPrograma === "usuarios") {
            const ids = nuevoObjeto.sectores || (nuevoObjeto.IdSector ? [nuevoObjeto.IdSector] : []);
            const nombresSectores = ids
                .map(id => sectores.find(s => s.IdSector === id)?.Nombre)
                .filter(Boolean);
            const usuarioConSector = {
                ...nuevoObjeto,
                Sector: nombresSectores.join(", ") || "Sin sector",
                sectores: ids,
            };

            if (nuevoObjeto.fechaRegistro) {
                usuarioConSector.fechaRegistro = formatearFecha(nuevoObjeto.fechaRegistro);
            }

            // Si no tiene sectores en la respuesta, re-fetch desde el backend
            if (ids.length === 0 && nuevoObjeto.IdUsuario) {
                try {
                    const sect = await api.usuarios.getSectores(nuevoObjeto.IdUsuario);
                    const sectIds = sect.map(s => s.IdSector);
                    usuarioConSector.sectores = sectIds;
                    usuarioConSector.Sector = sect.map(s => s.Nombre).join(", ") || "Sin sector";
                } catch (e) {
                    console.error("Error al re-fetch sectores:", e);
                }
            }

            // Actualiza la lista de usuarios con sector
            actualizarLista(usuariosConSector, setUsuariosConSector, "IdUsuario", usuarioConSector);
        } else {
            // Actualiza la lista principal con el nuevo objeto
            actualizarLista(config.state, config.setState, config.idKey, nuevoObjeto);
        }

        // Resetea la fila seleccionada
        setSelectedRow(null);
    };

    /**
     * Actualiza una lsita con un nuevo elemento o lo agrega si no existe.
     * @param {Array} lista - 
     * @param {Function} setLista - Función para actualizar la lista.
     * @param {string} campoId - Clave única para identificar el elemento.
     * @param {object} nuevo - Nuevo elemento a agregar o actualizar.
     */
    const actualizarLista = (lista, setLista, campoId, nuevo) => {
        const index = lista.findIndex(item => item[campoId] === nuevo[campoId]);
        if (index !== -1) {
            const nuevaLista = [...lista];
            nuevaLista[index] = nuevo;
            setLista(nuevaLista);
        } else {
            // setLista((prev) => [nuevo, ...prev]);
            setLista((prev) => [...prev, nuevo]);
        }
    };

    /**
     * Obtiene la lista de datos visible (sin los registros ocultos) y la invierte.
     * @return {Array} - La lista de datos filtrada.
     */
    const getListaDatos = () => {
        const datos = seccionPrograma === "usuarios" ? usuariosConSector : seccionesConfig[seccionPrograma]?.state || [];
        return datos.filter(item => item.oculto !== 1).reverse();
    };

    /**
     * Abre el cuadro de diálogo para confirmar ocultar un registro.
     * @param {object} row - El registro a ocultar.
     * @param {number} index - Índice del registro en la tabla.
     */
    const datosFiltrados = getListaDatos().filter(item =>
        Object.values(item).some(value =>
            String(value ?? "").toLowerCase().includes(searchText)
        )
    );

    /**
     * Abre el formulario para editar un registro.
     * @param {number} rowIndex - Índice del registro en la tabla.
     */
    const datosFiltradosPaginados = datosFiltrados.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    // --- useEffect para cargar los datos de rubros y sectores ---
    /**
     * Carga inicial de rubros y sectores al montar el componente.
     */
    useEffect(() => {
        const fetchData = async () => {
            var rubros = [];
            var sectores = [];
            const entradas = Object.entries(seccionesConfig);
            await Promise.all(entradas.map(async ([clave, config]) => {
                const data = await config.api.getAll();
                if (clave === 'rubro') {
                    rubros = data;
                }
                if (clave === 'sector') {
                    sectores = data;
                }
                if (clave === 'items') {
                    const itemsMapeados = data.map((items) => {
                        const rubro = rubros.find(r => r.IdRubro === items.idRubro);
                        return {
                            ...items,
                            Rubro: rubro ? rubro.Nombre : "Sin rubro",
                            IdRubro: rubro ? rubro.IdRubro : "Sin rubro",
                        };
                    })
                    config.setState(itemsMapeados);
                } else if (clave === 'usuarios') {
                    var sectores = await api.sectores.getAll();
                    const usuariosMapeados = data.map((usuario) => {
                        const ids = (usuario.sectores || (usuario.IdSector ? [usuario.IdSector] : [])).map(Number);
                        const nombresSectores = ids
                            .map(id => sectores.find(s => Number(s.IdSector) === id)?.Nombre)
                            .filter(Boolean);
                        return {
                            ...usuario,
                            Sector: nombresSectores.join(", ") || "Sin sector",
                            sectores: ids,
                        };
                    });
                    config.setState(usuariosMapeados);
                }
                // else if (clave === 'tipocomprobante') {
                //     config.setState(data);
                // } 
                else {
                    config.setState(data);
                }
            }));
        };
        fetchData();
    }, []);

    const handleOpenDialogClear = (row, index) => {
        // if (isAccionUsuariosRestringida) return;
        setSelectedRow(row);
        setOpen(true);
    };

    const handleOpenDialog = (rowIndex) => {
        // if (isAccionUsuariosRestringida) return;
        setSelectedRow(rowIndex);
        setOpenForm(true);
    };

    /**
     * Cambia la página actual de la tabla.
     * @param {object} event - Evento de cambio de página.
     * @param {number} newPage - Nueva página a mostrar.
     */
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    /**
     * Cambia la cantidad de filas por página en la tabla.
     * @param {object} event - Evento de cambio en el select de filas por página.
     */
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    /**
     * Maneja el cambio en el campo de búsqueda.
     * @param {object} event - Evento de cambio en el input de búsqueda.
     */
    const handleSearchChange = (event) => {
        const text = event.target.value.toLowerCase();
        setSearchText(text);

        setPage(0); // Resetear página cuando se realiza una búsqueda
    };

    /**
     * Cierra el cuadro de diálogo de confirmación.
     */
    const handleCloseDialog = () => {
        setOpen(false);
        setSelectedRow(null);
    };

    /**
     * Oculta un registro seleccionado actualizando su campo `oculto` en la base de datos.
     * @return {Promise<void>} - Una promesa que se resuelve cuando se actualiza la lista.
     */
    const handleHideRecord = async () => {
        if (!selectedRow || !seccionPrograma) return;

        const config = seccionesConfig[seccionPrograma];
        if (!config) return;

        const id = selectedRow[config.idKey];
        if (!id) return;

        try {
            await config.api.update(id, { oculto: 1 });
            const updatedList = config.state.map(item =>
                item[config.idKey] === id ? { ...item, oculto: 1 } : item
            );
            const visibles = updatedList.filter(item => item.oculto !== 1);

            // Recalcular número de páginas
            const newTotalPages = Math.ceil(visibles.length / rowsPerPage);
            const newPage = Math.min(page, newTotalPages - 1);

            config.setState(updatedList);
            setSelectedRow(null);
            setOpen(false);
            setPage(newPage >= 0 ? newPage : 0); // evitar números negativos

        } catch (error) {
            console.error("Error al ocultar el registro:", error);
        }
    };

    // --- Renderizado principal (JSX) ---
    /**
     * Renderiza el componente principal con la tabla de datos y los formularios modales.
     * @return {JSX.Element} - El JSX que representa la interfaz de usuario.
     */
    return (
        <>
            <div className={classes.dropdownContainer}>
                <Typography variant="h6" className="fw-bold">
                    Seleccione una lista para configurar
                </Typography>
                <FormControl className={classes.formControl} variant="outlined">
                    <InputLabel id="select-label">Seleccione una sección</InputLabel>
                    <Select
                        labelId="select-label"
                        value={seccionPrograma}
                        onChange={cambiarSeccion}
                        label="Seleccione una sección"
                    >
                        {listaConfiguraciones.map((op) => (
                            <MenuItem key={op.valor} value={op.valor}>
                                {op.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            {tablaReferencia && (
                <>
                    <Box
                        className={classes.sectionHeader}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <BotonGenerico
                            tipo="nuevo"
                            text="Nuevo"
                            onClick={() => { setOpenForm(true); setSelectedRow("") }}
                        />

                        <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Buscar"
                            value={searchText}
                            onChange={handleSearchChange}
                            className={classes.searchField}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                    <TableContainer component={Paper} className={classes.tableContainer}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    {columnasVisibles.map((col) => (
                                        <TableCell align="center" key={col.key}>{col.label}</TableCell>
                                    ))}
                                    <TableCell align="center">Opciones</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {datosFiltradosPaginados.map((item, index) => (
                                    // <TableRow key={item[seccionesConfig[seccionPrograma]?.idKey]}>
                                    <TableRow key={`lista-${item[seccionesConfig[seccionPrograma]?.idKey]}`}>
                                        {columnasVisibles.map((col) => (
                                            <TableCell align="center" key={col.key}>
                                                {col.key === "Contraseña"
                                                    ? (item[col.key] !== undefined && item[col.key] !== null ? "**********" : "-")
                                                    : (item[col.key] !== undefined && item[col.key] !== null ? item[col.key] : "-")}
                                            </TableCell>
                                        ))}
                                        <TableCell align="center">
                                            {/* {!isAccionUsuariosRestringida ? (
                                                <> */}
                                            <IconButton onClick={() => handleOpenDialog(item)}>
                                                <SearchIcon color="primary" />
                                            </IconButton>
                                            <IconButton onClick={() => handleOpenDialogClear(item)}>
                                                <DeleteIcon color="secondary" />
                                            </IconButton>
                                            {/* </>
                                            ) : (
                                                "-"
                                            )} */}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        // count={getListaDatos().length}
                        count={datosFiltrados.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                        labelRowsPerPage="Filas por página"
                    />

                    <CrearConfiguracion
                        open={openForm}
                        onClose={() => setOpenForm(false)}
                        tipo={seccionPrograma}
                        onSuccess={agregarElemento}
                        editando={selectedRow}
                        sectores={sectores.filter(item => item.oculto !== 1)}
                        rubros={rubro.filter(item => item.oculto !== 1)}
                        listaUsuarios={usuariosConSector}
                    />

                    <Dialog open={open} onClose={handleCloseDialog}>
                        <DialogTitle className={classes.dialogTitle}>
                            <ErrorOutlineIcon className={classes.errorIcon} />
                            <Typography variant="h6" gutterBottom>
                                Ocultar Registro
                            </Typography>
                        </DialogTitle>
                        <DialogContent className={classes.dialogContent}>
                            <Typography>
                                Los registros ocultados solo serán recuperados por el Administrador.
                            </Typography>
                        </DialogContent>
                        <DialogFooter>
                            <BotonGenerico
                                tipo="guardar"
                                text="Ocultar registro"
                                onClick={handleHideRecord}
                            />
                            <BotonGenerico
                                tipo="cancelar"
                                text="Cancelar"
                                onClick={handleCloseDialog}
                            />
                        </DialogFooter>
                    </Dialog>
                </>
            )}
        </>
    );
};

export default Configuraciones;
